import {
	GovControlGroup,
	GovDropdown,
	GovIcon,
} from '@gov-design-system-ce/react';
import { useLocale } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';
import { Button } from '@gov-nx/ui/web';
import cx from 'classnames';

interface DataBoxArchiveRemoveDropdownProps {
	isDisabled: boolean;
	onDeleteSomeMessages: () => void;
	onDeleteAllMessages: () => void;
}

export const DataBoxArchiveRemoveDropdown = ({
	isDisabled,
	onDeleteSomeMessages,
	onDeleteAllMessages,
}: DataBoxArchiveRemoveDropdownProps) => {
	const { t } = useLocale(PageCode['datove-schranky']);
	return (
		<GovControlGroup
			color="primary"
			className="w-auto border-hidden! [ xl:border-solid! ]">
			<Button
				color="primary"
				type="base"
				size="s"
				isDisabled={isDisabled}
				onClick={onDeleteAllMessages}
				className={cx(
					isDisabled && 'border-r-primary-300!',
					'hidden! [ xl:inline-block! ]'
				)}
				aria-label={t('zpravy.vypis.hromadne-mazani-vse')}
				iconStart={
					<GovIcon
						name="trash"
						type="templates"
					/>
				}>
				{t('zpravy.vypis.hromadne-mazani-vse')}
			</Button>
			<GovDropdown
				position="right"
				color="primary"
				type="base"
				size="s"
				disabled={isDisabled}
				label={
					<>
						<GovIcon
							name="chevron-down"
							type="components"
							className="hidden! [ xl:inline-flex! ]"
						/>
						<GovIcon
							name="trash"
							type="templates"
							className="[ xl:hidden! ]"
						/>
					</>
				}>
				<Button
					color="error"
					type="base"
					size="s"
					isExpanded
					isDisabled={isDisabled}
					className="button-fixed-width"
					onClick={onDeleteAllMessages}
					aria-label={t('zpravy.vypis.hromadne-mazani-vse')}
					iconStart={
						<GovIcon
							name="trash"
							type="templates"
						/>
					}>
					{t('zpravy.vypis.hromadne-mazani-vse')}
				</Button>
				<Button
					color="error"
					type="base"
					size="s"
					isDisabled={isDisabled}
					onClick={onDeleteSomeMessages}
					aria-label={t('zpravy.vypis.hromadne-mazani')}
					iconStart={
						<GovIcon
							name="trash"
							type="templates"
						/>
					}>
					{t('zpravy.vypis.hromadne-mazani')}
				</Button>
			</GovDropdown>
		</GovControlGroup>
	);
};
